// =====================================
//
//   快速下單 Modal
//   Author: Gray
//   createtime: 2016 / 02 / 18
//   updatetime: 2016 / 02 / 18
//
// =====================================

window.InifECApp.directive('quicklyOrder', ['$rootScope', '$ngModal', '$timeout', 'ProductService', '$state', 'UserService', '$ProductFormatService',
	function ($rootScope, $ngModal, $timeout, ProductService, $state, UserService, $ProductFormatService) {

		var _dir = {};

		var link = function(scope, element, attrs) {}

		var controller = ['$scope', '$element',
			function($scope, $element) {

			var openModal = function() {
				$ngModal.openModal("quickly-order");
				$element.find('.content').scrollTop(0);
			}

			var closeModal = function() {
				$ngModal.closeModal("quickly-order");
			}

			var getPdtClassList = function() {

				if($scope.isLoading || $scope.isLoaded) {
					return;
				}

            	$scope.isLoading = true;
	            ProductService.getPdtClassList().then(function(result) {
	                if(result) {

	                	$scope.pdtClassList = $ProductFormatService.getPdtClassList('MODAL');

	                	if(!$scope.pdtClassList || $scope.pdtClassList.length == 0) {
	                		var _result = shallowCopy(result);

	                    	$scope.pdtClassList = $ProductFormatService.formatModalPdtClassList(_result);
	                    }
	                    getPdtClassListSuccess();
	                }

	                $scope.isLoaded = true;
	                $scope.isLoading = false;
	            }, function(error) {
	                $scope.isLoading = false;
	                $scope.isError = true;
	            });
	        }

	        var getPdtClassListSuccess = function() {

	        	if($scope.pdtClassList.length > 0 && !$scope.form.mainPdtClass) {
	        		// changeMainPdtClass($scope.pdtClassList[0]);
	        	}
	        }

			var changeMainPdtClass = function(mainPdtClass){
				if($scope.form.mainPdtClass == mainPdtClass){
					return;
				}

				$scope.form.mainPdtClass = mainPdtClass;

				if($scope.form.pdtClass || mainPdtClass.pdtClasses.length == 1) {
					changePdtClass(mainPdtClass.pdtClasses[0]);
				}
			}

			var changePdtClass = function(pdtClass) {
				if($scope.form.pdtClass == pdtClass) {
					return;
				}

				$scope.form.pdtClass = pdtClass;

				if($scope.form.product || pdtClass.products.length == 1) {
					changeProduct(pdtClass.products[0]);
				}
			}

			var changeProduct = function(product) {
				if($scope.form.product == product) {
					return;
				}

				$scope.form.product = product;
			}

			var resetSelectProduct = function() {
				
				$scope.form.mainPdtClass = undefined;
				$scope.form.pdtClass = undefined;
				$scope.form.product = undefined;
			}

			var init = function() {

				resetSelectProduct();

				if($scope.isLoaded){
					return;
				}

				getPdtClassList();
			}
			
			//==========================
	        //  Events
	        //==========================
	        $scope.$on("OPEN_QUICKLY_ORDER_MODAL", function(event, data) {
	        	init();
				openModal();
			});

			$scope.$on("OPEN_MODAL_COMPLETE", function(event, data){
				if(data && data == "quickly-order"){
					init();					
				}
			});

	        //==========================
	        //  Members
	        //==========================
	        $scope.isLoading = false;
	        $scope.isLoaded = false;
	        $scope.pdtClassList = [];
	        $scope.form = {
	        	mainPdtClass: undefined,
	        	pdtClass: undefined,
	        	product: undefined
	        };
	        $scope.user = UserService.user;

	        //==========================
	        //  Methods
	        //==========================
	        $scope.changeMainPdtClass = changeMainPdtClass;
	        $scope.changePdtClass = changePdtClass;
	        $scope.changeProduct = changeProduct;

	        //==========================
	        //  Init
	        //==========================


		}]

		_dir.scope = true;
		_dir.restrict = 'E';
		_dir.templateUrl = 'partials/modal/quickly_order.html';
		_dir.link = link;
		_dir.controller = controller;
		
		return _dir;
	}
]);